/**
 * Shared delay for hiding phone dropdown after click-outside (add-customer-modal, customer-info).
 */
export const HIDE_PHONE_DROPDOWN_DELAY_MS = 200;

/**
 * Hide a dropdown after a short delay (e.g. to allow click to register before closing).
 */
export function hideDropdownAfterDelay(
  hide: () => void,
  delayMs: number = HIDE_PHONE_DROPDOWN_DELAY_MS
): void {
  setTimeout(hide, delayMs);
}
